import { Typography } from "@mui/material";
import React from "react";
import { DARCKCOLOR } from "../../helpers/Config";
import { sxText1640024 } from "../../theme/sxStyle";

const CustomLoading = () => {
  return (
    <Typography
      variant="h6"
      width={"100%"}
      my={2}
      sx={{
        ...sxText1640024,
        color: DARCKCOLOR,
        textAlign: "center",
      }}
    >
      Loading...
    </Typography>
  );
};

export default CustomLoading;
